export default __webpack_public_path__ + "static/media/DevMobile.57f72703.png";